// import { useParams } from "react-router-dom";
import { Typography, Box, Divider,Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
const DetailsPage = () => {
  const { state } = useLocation();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
//   const destination = destinations[Number(index)]; // Convert index to number and get project
if (!state?.destination) {
    return <Typography variant="h4">Destination Not Found</Typography>;
  }
  return (
    <Box sx={{p: 4, textAlign: "center", backgroundColor: '#ffffff', width: '100%', minWidth: '100%',}}>
          <Box
      sx={{
        flexDirection: 'column',
        position: "relative",
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "transparent",
      }}
    >
      <img src={state.destination.bgImage} alt="" style={{ 
        minWidth: '100%',  width: '100%', 
  height: '100%', 
  objectFit: 'cover', 
  position: 'fixed', 
  top: 0, 
  left: 0, 
  zIndex: -1 }}/>
      {/* Fixed Background */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1, // ✅ Sends it behind the text
        }}
      />
      <Box py={5} marginInline={{ md: 19, xs: 1 }} >
   <Grid container spacing={4} alignItems="start">
          {/* Text Content */}
          <Grid item xs={12} md={8} >
  <Typography 
    variant="h4" 
    fontWeight="bold" 
    gutterBottom 
    sx={{ 
      fontFamily: 'Montserrat', 
      margin: { xs: '20px auto', md: '20px 0' }, 
      textAlign: { xs: 'center', md: isArabic ? 'right' : 'left' } // Align text to the left
    }}
  >
    {t(`${state.destination.key}.subtitle`)}
  </Typography>
        <Divider sx={{ backgroundColor: 'primary.main', width: '15vh', height: '3px' ,margin: { xs: '20px auto', md: isArabic ? '20px 0 20px auto' : '20px auto 20px 0'} }} />
  {t(`${state.destination.key}.subtitleDescription`, { returnObjects: true }).map((std, index) => (
    <Typography
      key={index}
      variant="h6"
      sx={{ 

        width: "100%", 
        height: "auto", 
        mt: 2, 
        fontFamily: 'Noto Sans', 
        textAlign: isArabic ? 'right' : 'left' // Align text to the left
      }}
    >
      {std}
    </Typography>
  ))}
          
          </Grid>

          {/* Logo Section */}
          <Grid item xs={12} md={4} display="flex" justifyContent="center" alignItems="start" flexDirection="column">
        {state.destination.vd.length!==0 &&(
          <video
          
            autoPlay
            controls  
            style={{ width: '100%',minWidth: '100%',borderRadius: '10px'}}
          >
            <source
              src={state.destination.vd[0]}
              type="video/mp4"
            />
          </video>
        )}
       
       
            {state.destination.destinationTravelimg.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="Destination"
                style={{ width: "100%", backgroundColor: '#13294b' ,borderRadius: '10px',margin: '20px 0'}}
              />
            ))}
          </Grid>
        </Grid>
</Box>
      </Box>
    </Box>
  );
};

export default DetailsPage;
